var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 13.3546C6.95794 13.3546 4.81178 11.8117 4 9.67728C4.81178 7.54286 6.95794 6 9.50002 6C12.0421 6 14.1882 7.54286 15 9.67728C14.1882 11.8117 12.0421 13.3546 9.50002 13.3546Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3232 9.67729C11.3232 10.6842 10.5069 11.5005 9.50002 11.5005C8.4931 11.5005 7.67683 10.6842 7.67683 9.67729C7.67683 8.67037 8.4931 7.8541 9.50002 7.8541C10.5069 7.8541 11.3232 8.67037 11.3232 9.67729Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.f3c2b823c5a3fe2c04ea0614a132eb30.svg";
export { ForwardRef as ReactComponent };